import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { FavoritosService } from './../../services/favoritos.service';
import { Material } from './../../models/material.model';
import { MaterialService } from './../../services/material.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-favoritos',
  templateUrl: './favoritos.component.html',
  styleUrls: ['./favoritos.component.scss']
})
export class FavoritosComponent implements OnInit {
  buttonList = {
    backButton: true,
    groupButton: false,
    searchButton: false,
    viewButton: true,
    favButton: false,
    favAllButton: false,
    inFavButton: true,
  }
  toggleView: boolean;
  public material$: Observable<Material[]>;
  favoritosList;
  showItems = 20;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _toastr: ToastrService,
    private _cookie: CookieService,
    private _material: MaterialService,
    private _favoritos: FavoritosService
  ) {
    const getView = this._cookie.get('focusListView');
    if (getView !== '') {
      this.toggleView = (getView === 'true');
    } else {
      this.toggleView = true;
    }
  }

  ngOnInit() {
    this._favoritos.favoritosList.subscribe(list => this.favoritosList = list);
    this.meusFavoritos();
  }

  meusFavoritos() {
    if (localStorage.getItem("favoritos") === null) {
      this._favoritos.listFav()
        .subscribe(
          (response: any) => {
            localStorage.setItem('favoritos', JSON.stringify(response));
            this.favoritosList = response[0].Itens.map(result => result.MATNR);
            this._router.navigate(['/catalogo']);
          }
        );
    } else {
      this.favoritosList = JSON.parse(localStorage.favoritos)[0].Itens.map(result => result.MATNR);
      this.getMaterial();
    }
  }

  getMaterial() {
    this.material$ = this._material.listFavorite(this.favoritosList);
    if (localStorage.getItem('itemLocation') != null) {
      let itemLocation = localStorage.getItem('itemLocation');
      localStorage.removeItem('itemLocation');
      this.goToItemPosition(itemLocation);
    }
  }

  goToItemPosition(itemLocation) {
    const self = this;
    const itemPosition = document.getElementById(itemLocation);
    if (itemPosition != null) {
      window.scroll({ top: itemPosition.offsetTop, left: 0, behavior: 'smooth' });
    } else {
      this.showItems += 20;
      setTimeout(function() {
        self.goToItemPosition(itemLocation);
      }, 100);
    }
  }

  trackByFn(index, item) {
    index
  }

  listenToggleView(status: boolean):void {
    this.toggleView = status;
  }

  listenPrintAll(status: boolean):void {
    this.showItems = this.favoritosList.length;
    setTimeout(function(){
      window.print()
    }, 600)
  }

  onScrollDown() {
    this.showItems += 20;
  }

}
